/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GUI                                      from 'services/gui';
import { ResponseParser }                       from 'utils/parsers';
import { getAlphanumericPropertiesFromFeature } from 'utils/getAlphanumericPropertiesFromFeature';
import { getCatalogLayerById }                  from 'utils/getCatalogLayerById';

const __vue_script__ = {
  name: 'Infoformats',

  props: {
    layer: {
      type:     Object,
      required: true
    }
  },

  data() {
    return {
      infoformat: this.layer.infoformat
    }
  },

  computed: {
    infoformats() {
      return this.layer.infoformats || [];
    },

    /**
     * Whether to show info formats for layer (eg. wms external layer).
     * 
     * @since 3.8.1
     */
    hasInfo() {
      return this.infoformats.length;
    }

  },

  methods: {

    async reloadLayerDataWithChangedContentType(contenttype) {
      this.layer.loading = true;
      // disable select during get data from server
      this.$el.disabled = true;
      try {
        const response = await this.projectLayer.changeProxyDataAndReloadFromServer('wms', {
          headers: { 'Content-Type': contenttype },
          params:  { INFO_FORMAT: contenttype }
        });
        this.layer.infoformat = contenttype;
        this.projectLayer.setInfoFormat(this.layer.infoformat);
        const [data] = ResponseParser.get(contenttype)({ layers: [this.projectLayer], response });
        if (data.features) {
          this.__parsedata(data);
        } else {
          this.__parserawdata(data);
        }
      } catch (e) {
        console.warn(e);
      }
      this.layer.loading = false;
      // enable select during get data from server
      this.$el.disabled = false;
    },

    /**
     * @TODO find me a better name
     */
    __parsedata(data) {
      const queryService = GUI.getService('queryresults');
      this.layer.rawdata = null;

      data.features.forEach(feature => {

        const {
          id: fid,
          geometry,
          properties:attributes
        } = {
          properties: feature instanceof ol.Feature ? feature.getProperties() : feature.properties,
          geometry:   feature instanceof ol.Feature ? feature.getGeometry()   : feature.geometry,
          id:         feature instanceof ol.Feature ? feature.getId()         : feature.id
        };

        // in the case of starting raw data (html) need to sett attributes to visualize on a result
        if (0 === this.layer.attributes.length) {
          this.layer.hasgeometry = !!geometry;
          // need to setActionsForLayers to visualize eventual actions
          queryService.setActionsForLayers([this.layer]);
          getAlphanumericPropertiesFromFeature(attributes).forEach(name =>{
            this.layer.attributes.push({
              name,
              label:name,
              show: true
            })
          })
        }

        this.layer.features.push({ id: fid, attributes, geometry, show: true });
      });
    },

    /**
     * @TODO find me a better name 
     */
    async __parserawdata(data) {
      this.layer.features.splice(0);
      await this.$nextTick();
      this.layer.rawdata = data.rawdata;
    },

  },

  watch: {
    'infoformat'(value) {
      this.reloadLayerDataWithChangedContentType(value);
    }
  },

  created() {
    this.projectLayer = getCatalogLayerById(this.layer.id);
  },

  beforeDestroy() {
    if (this.projectLayer) {
      this.projectLayer.clearProxyData('wms');
    }
    this.projectLayer = null;
  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasInfo)?_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('infoformat'),expression:"'infoformat'"}],staticClass:"skin-color",attrs:{"select2_value":_vm.infoformat,"search":false}},_vm._l((_vm.infoformats),function(infoformat){return _c('option',{key:infoformat,domProps:{"value":infoformat}},[_vm._v("\n    "+_vm._s(infoformat)+"\n  ")])}),0):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "QueryResultsActionInfoFormats.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__